import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Quote, Plus, Trash2, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export const HeroPhrasesAdmin = () => {
  const [rows, setRows] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/hero/phrases").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post("/admin/hero/phrases", { text: text.trim() }); toast.success("Frase agregada"); setText(""); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); if (ok) toast.success(ok); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const toggle = (p) => run(() => api.patch(`/admin/hero/phrases/${p.id}`, { active: !p.active }));
  const del = (id) => run(() => api.delete(`/admin/hero/phrases/${id}`), "Frase eliminada");
  const active = rows.filter((r) => r.active).length;

  return (
    <Card className="p-5" data-testid="hero-phrases-card">
      <h3 className="font-bold flex items-center gap-2 mb-1"><Quote className="w-5 h-5 text-primary" />Frases de Portada</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Completan «Vive un mundo de …». Se elige una al azar entre las activas <strong>solo al iniciar una nueva visita</strong>; nunca cambia mientras el usuario navega. Activas: <strong data-testid="hero-phrases-active-count">{active}</strong>.
      </p>
      <div className="flex gap-2 mb-4">
        <Input value={text} maxLength={40} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Ej: experiencias reales" data-testid="hero-phrase-input" />
        <Button onClick={add} disabled={busy || !text.trim()} className="shrink-0" data-testid="add-hero-phrase-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Plus className="w-4 h-4 mr-1" />Agregar</>}
        </Button>
      </div>
      <div className="space-y-2" data-testid="hero-phrases-list">
        {rows.map((p) => (
          <div key={p.id} className={`flex items-center justify-between gap-3 rounded-lg border p-3 ${p.active ? "" : "opacity-60"}`} data-testid={`hero-phrase-row-${p.id}`}>
            <p className="text-sm"><span className="text-muted-foreground">Vive un mundo de </span><strong>{p.text}</strong></p>
            <div className="flex items-center gap-2 shrink-0">
              <Switch checked={p.active} onCheckedChange={() => toggle(p)} disabled={busy} data-testid={`toggle-hero-phrase-${p.id}`} />
              <button onClick={() => del(p.id)} disabled={busy} className="text-destructive disabled:opacity-40" data-testid={`delete-hero-phrase-${p.id}`} aria-label="Eliminar frase"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-muted-foreground py-2">Sin frases. Se mostrará «talleres presenciales».</p>}
      </div>
    </Card>
  );
};
